import clsx from 'clsx';
import { FunctionComponent, ReactNode } from 'react';
import styles from './ListCardRow.module.scss';

interface ListCardRowProps {
    className?: string;
    children?: ReactNode;
}

// A card section: flex row with its content spread to the edges. Consecutive rows are separated
// by a divider automatically.
export const ListCardRow: FunctionComponent<ListCardRowProps> = props => {
    return <div className={clsx(styles.row, props.className)}>{props.children}</div>;
};

export default ListCardRow;
